import ImgCrop from 'antd-img-crop';

export const CropOrNotWrapper = ({
  children,
  enable,
  width,
  height,
}: {
  children: JSX.Element;
  enable?: boolean;
  width?: number;
  height?: number;
}) => {
  if (enable) {
    return (
      <ImgCrop
        modalTitle="Chỉnh sửa hình ảnh"
        aspect={width && height && width / height}
      >
        {children}
      </ImgCrop>
    );
  }
  return <>{children}</>;
};
